import React, { useState, useEffect, useRef } from "react";
import classNames from "classnames";
import styles from "./AdRotator.module.css";

const DISPLAY_TIME_MS = 15 * 1000;

const AdRotator = ({ size, ads }) => {
  const [current, setCurrent] = useState(0);
  const intervalRef = useRef(null);

  const startAutoplay = () => {
    if (intervalRef.current) clearInterval(intervalRef.current);
    if (ads.length <= 1) return;

    intervalRef.current = setInterval(() => {
      setCurrent((prev) => (prev + 1) % ads.length);
    }, DISPLAY_TIME_MS);
  };

  useEffect(() => {
    startAutoplay();
    return () => clearInterval(intervalRef.current);
  }, [ads.length]);

  const goToSlot = (index) => {
    setCurrent(index);
    startAutoplay();
  };

  const openInNewTab = (url) => {
    const newWindow = window.open(url, "_blank", "noopener,noreferrer");
    if (newWindow) newWindow.opener = null;
  };

  const ad = ads[current];

  return (
    <div className={styles.rotator}>
      <div
        className={classNames(styles.adSpaceButton, {
          [styles.small]: size === "small",
          [styles.large]: size === "large",
        })}
      >
        <img src={ad.image} alt={ad.alt} onClick={() => openInNewTab(ad.link)} />
      </div>
      {ads.length > 1 && (
        <div className={styles.dots}>
          {ads.map((_, index) => (
            <span
              key={index}
              className={classNames(styles.dot, {
                [styles.dotActive]: index === ads.length - 1 - current,
              })}
              onClick={() => goToSlot(index)}
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default AdRotator;
